import { getFormattedFutureDate } from "@website/utils/date-format";

const DATE_OFFSET = Number(process.env["NEXT_PUBLIC_DAYS_OFFSET"]);
const getOffset = (fallback: number) => DATE_OFFSET || fallback;

export const getToday = () => new Date();
export const getFormattedToday = () => getFormattedFutureDate(0);

export const getInterFlightDefaultDepartureDate = () =>
  getFormattedFutureDate(getOffset(3));

export const getDomFlightDefaultDepartureDate = () =>
  getFormattedFutureDate(getOffset(1));

export const getBusFormattedFutureDate = () =>
  getFormattedFutureDate(getOffset(1));

export const getTrainFormattedFutureDate = () =>
  getFormattedFutureDate(getOffset(3));

export const getFlightDefaultDepartureDate = (
  product: "dom-flight" | "inter-flight"
) =>
  product === "dom-flight"
    ? getDomFlightDefaultDepartureDate()
    : getInterFlightDefaultDepartureDate();
